module.exports = __webpack_public_path__ + "static/img/公众号.ab80739.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/公众号.png
// module id = SwtH
// module chunks = 1